import { GET_NDHM_HOST } from "../../constants/env";
import fetch from "../../fetch-client";
import { AxonGenericApiResponse } from "../../types/axon";

export default async function postCreateHpr({
  txnId,
  hprId,
  doctor_oid,
  email,
}: {
  txnId: string;
  hprId: string;
  doctor_oid: string;
  email: string,
}): Promise<AxonGenericApiResponse<{ hprId: string }>> {
  try {
    const NDHM_HOST = GET_NDHM_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const body = JSON.stringify({ txnId, hprId,email });
    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body,
      mode: "cors",
      credentials: "include",
    };
    const response = await fetch(`${NDHM_HOST}/abdm/nhpr/v1/hpr/aadhaar/create?doctor_oid=${doctor_oid}`, requestOptions);
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
